import { hashKey, useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAppContext } from 'src/contexts/AppContext';
import { ErrorTypes, useClientLogContext } from 'src/contexts/ClientLogContext';
import {
  EventConfigClient,
  EventListingConstraints,
} from 'src/WebApiController';

export const useGetEventListingConstraints = (eventIds: number[]) => {
  const { activeAccountWebClientConfig } = useAppContext();
  const { trackError } = useClientLogContext();

  const uniqueEventIds = useMemo(() => new Set(eventIds), [eventIds]);

  const query = useQuery({
    queryKey: [
      'EventConfigClient.getListingConstraintsForEvents',
      hashKey([uniqueEventIds]),
    ],
    queryFn: async () => {
      if (!eventIds.length) {
        return null;
      }
      const results = await new EventConfigClient(
        activeAccountWebClientConfig
      ).getListingConstraintsForEvents(Array.from(uniqueEventIds));

      if (results) {
        return results.reduce(
          (r, c) => {
            r[c.eventId] = c;
            return r;
          },
          {} as Record<number, EventListingConstraints>
        );
      }

      return null;
    },

    refetchOnWindowFocus: false,
    meta: {
      onError: (error: ErrorTypes) => {
        trackError('EventConfigClient.getListingConstraintsForEvents', error, {
          trackErrorData: {
            uniqueEventIds,
          },
        });
      },
    },
  });

  return {
    eventListingConstraintsQuery: query,
  };
};
